














































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import sessionModule, { IUserSession } from '@/store/modules/session';
import classList from '../components/Home/classList.vue';
import classInfo from '@/components/common/classInfo.vue';
import { TrainClassDto, ClassState, PersonalTrainSummary } from '@/api/models';
import axios from 'axios';
import UserModule from '@/store/modules/user';
import personInfoForm from '@/components/common/personInfoForm.vue';
import classSignin from '@/components/common/classSignin.vue';
import userModel from '@/store/modules/user';
import { Dialog } from 'vant';
@Component({
  components: { classList, classInfo, personInfoForm, classSignin },
})
export default class Home extends Vue {
  @State(s => s.session.activeSession) currentSession: IUserSession;
  readonly userModule = UserModule.info;
  readonly module = UserModule;
  deptName: string = '';
  isLoading: boolean = false;
  loading: boolean = false;
  finished: boolean = false;
  allDays: number = 0;
  active: number = 0;
  current: number = 0;
  pendingClassCounts: number = 0;
  trainingCount: number = 0;
  pxClassesList: TrainClassDto[] = [];
  bmClassesList: TrainClassDto[] = [];
  showEditPersonInfo: boolean = false;
  showClassSignin: boolean = false;
  personalTrainSummary: any = {};
  trainingDays: any[] = [];
  headerStyles: any = {
    backgroundImage: 'url(' + require('@/images/首页底图@2x.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  swipeStyle: any = {
    backgroundImage: 'url(' + require('@/images/swider.png') + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    paddingBottom: '15px',
  };
  icon: any = {
    active: 'https://img.yzcdn.cn/vant/user-active.png',
    inactive: 'https://img.yzcdn.cn/vant/user-inactive.png',
  };

  classId: string | null = '';
  opreateType: string | null = '';
  classType: string | null = '';
  studentInfo: any = {};
  classObj: any = {};
  stuImg: string = null;
  dates: any = [];

  get userType() {
    return parseInt(UserModule.info.type);
  }

  platformBind() {
    this.$router.push({
      path: '/platformBind',
      query: {
        openId: this.studentInfo.openId,
      },
    });
  }

  percentage(a, b) {
    return (a / b) * 100;
  }
  /**获取全部单位 */
  async getAllDepts() {
    const { data } = await api.AccountApp.getAllDepts_GET();
    this.deptName = data.find((e: { deptId: any }) => this.userModule.deptId == e.deptId).deptName;
  }

  getYearDay() {
    let year = new Date().getFullYear();
    this.dates = [year, year - 1, year - 2, year - 3, year - 4];
  }

  tabbarChange() {
    if (this.active == 2) {
      this.$router.push('/personal/index');
    }
  }

  onChange(index: number) {
    this.current = index;
  }

  // 获取学员信息
  async getStuInfo() {
    const { data } = await api.AccountApp.getUserPersonalInfo_GET();
    this.studentInfo = data;
  }
  // 获取学员头像
  async getStuImg(keyName: string, key: string) {
    if (/^https:\/\/appapi\.gxela\.gov\.cn.*/.test(key)) {
      this.stuImg = key;
    } else {
      const { data } = await apiAxios.get('/api/NewAttachment/GetAttachmens', {
        params: {
          StringKey1: key,
          Category: keyName,
        },
      });
      if (data && data.length > 0) this.stuImg = data[0].id;
    }
  }

  async getClasses() {
    try {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: ClassState.培训中,
      });
      this.pxClassesList = data?.items!;
      this.trainingCount = this.pxClassesList?.length;
      // {
      //   const { data } = await api.ClassSolution.findClassSolutions_GET({
      //     state: ClassState.培训中,
      //   });
      //   this.bmClassesList = data?.items!;
      // }
    } catch (e) {
      console.log('%c [ e ]-314', 'font-size:13px; background:pink; color:#bf2c9f;', e);
    }
  }

  /**近5年培训情况 */
  async getTrainDays() {
    this.loading = true;
    this.dates = this.dates.sort((a, b) => {
      return b - a;
    });
    try {
      const { data } = await api.AccountApp.getTrainDays_GET({
        startYear: this.dates[this.dates.length - 1],
        endYear: this.dates[0],
      });
      this.personalTrainSummary = data;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }

  async onLoad() {
    await this.getClasses();
  }

  async mounted() {
    let that = this;

    this.getAllDepts();
    if (that.$route.query.classId) {
      that.classId = that.$route.query.classId.toString();
    }
    if (that.$route.query.opreateType) {
      that.opreateType = that.$route.query.opreateType.toString();
    }
    if (that.$route.query.classType) {
      that.classType = that.$route.query.classType.toString();
    }
    that.getAllHours();
    //获取待报到培训班数量
    that.getPendingClassCounts();
    this.getYearDay();
    //获取学员头像
    await that.getStuInfo();
    await that.getClassById(that.classId, that.classType);
    await that.checkOpeningReport();
    // await that.getClasses();
    await that.getTrainDays();
    await that.getStuImg('学员头像', this.studentInfo.imageName);
  }
  //根据id获取培训班
  async getClassById(id: any, type: any) {
    const { data } = await api.ClassSolution.findOneById_GET({ id: id, type: type });
    this.classObj = data;
  }
  //开班报道检测
  async checkOpeningReport() {
    let that = this;
    if (that.classId && that.opreateType && that.classType) {
      await that.checkPersonInfo();
      if (that.showEditPersonInfo == false) {
        that.showClassSignin = true;
      }
    }
  }
  //开班报道成功回调
  async classEditSuccess() {
    await this.getPendingClassCounts();
    await this.getClasses();
    this.showClassSignin = false;
    if (!this.studentInfo.job || this.studentInfo.job == '暂无' || this.studentInfo.job == '无') {
      Dialog({
        message: '请填写正确的职务后操作',
        beforeClose: (action, done) => {
          this.$router.push({
            name: 'editUserInfo',
          });
          done();
        },
      });
    }
  }
  //个人信息检测
  async checkPersonInfo() {
    let that = this;

    let deptId = that.studentInfo.deptId;
    let name = that.studentInfo.name;
    let phone = that.studentInfo.phone;
    let workUnit = that.studentInfo.workUnit;
    let job = that.studentInfo.job;
    let nation = that.studentInfo.nation;
    if (deptId) await that.getDeptNameWithId();
    if (deptId && name && phone && workUnit && job) {
      that.showEditPersonInfo = false;
    } else {
      that.showEditPersonInfo = true;
    }
  }
  //个人信息完善成功回调
  async psEditSuccess() {
    let that = this;
    await that.checkPersonInfo();
  }
  //获取学员部门名称
  async getDeptNameWithId() {
    let that = this;

    const { data } = await apiAxios.get('/api/Dept/GetDeptNameById', {
      params: {
        id: that.studentInfo.deptId,
      },
    });
    that.studentInfo.deptName = data.data.name;
  }
  //获取已获得学时
  async getAllHours() {
    const { data } = await api.AccountApp.getSumDays_GET({ year: null });
    this.allDays = data.days;
  }

  async getPendingClassCounts() {
    const { data } = await api.ClassSolution.getPendingClassCounts_GET();
    this.pendingClassCounts = data;
  }
}
export interface AxiosRequestConfig {
  baseURL?: string;
  headers: object;
}
const axiosOptions: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_ROOT,
  headers: {
    Authorization: `${'Bearer ' + UserModule.getToken}`,
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
};
const apiAxios = axios.create(axiosOptions);
